import type { AdminUserStatus } from '@mds/shared/types/admin';

/** The chip classes each administrator status is drawn in. */
export const statusTone = (status: AdminUserStatus) =>
  status === 'active'
    ? 'border-mint/35 bg-mint-wash text-mint-deep'
    : status === 'pending'
      ? 'border-warn-edge bg-warn-wash text-warn'
      : status === 'suspended'
        ? 'border-danger-edge bg-danger-wash text-danger'
        : 'border-line bg-ink/[0.05] text-ink-muted';

/** Every status, in the order the filter offers them. */
export const ADMIN_STATUSES: AdminUserStatus[] = ['active', 'pending', 'suspended', 'deactivated'];
